<div *ngIf="attendee" (mouseenter)="hovered=true" (mouseleave)="hovered=false" class="group p-3 border-t border-slate-900">
  <div class="flex flex-row justify-between items-center">

    <div class="flex flex-row items-center gap-3">
      <app-avatar *ngIf="attendee.roomRunBy" class="shrink-0" [user]="attendee.roomRunBy" size="sm"></app-avatar>
      <div>
        <p>
          <span class="text-lg">{{attendee.roomName}}</span>
          <span *ngIf="attendee.roomRunBy">
            <span class="text-muted"> with </span>
            <span class="text-lg">{{attendee.roomRunBy.givenName}} {{attendee.roomRunBy.familyName}}</span>
          </span>
        </p>
        <p class="text-sm">
          <span class="text-muted">Attended</span>
          {{attendee.joinedAt | timeago}}
        </p>
      </div>
    </div>

    <div class="flex flex-row gap-6 text-center">
      <div>
        <span class="text-lg">{{attendee.points!.pointsEarned}}</span>
        <br/>
        <span class="text-muted text-sm">points</span>
      </div>
    </div>
  </div>

  <div *ngIf="hovered" [@fadeInOut] class="pt-3 overflow-hidden">
    <p>
      {{attendee.points.participationScore | percent}}
      <span class="text-muted">participation</span>
      &nbsp;&nbsp;
      {{attendee.points.knowledgeScore | percent}}
      <span class="text-muted">understanding</span>
      (<a (click)="requestDetails()">details</a>)
    </p>
  </div>
</div>
